// Build-mode narration sanitiser used by the chat-message renderer.
//
// Build mode is SILENT in the chat — the renderer drops the model's
// natural-language prose entirely, since the operator already sees
// the tool chips below it. This module's only remaining job is the
// corruption guard: hide messages whose raw text contains provider-
// side token leakage (the MiniMax fence-loop spew), where surfacing
// the bytes would clutter the UI with 50× duplicated garbage AND
// confuse the fence parser. Detection happens on raw text BEFORE any
// other rendering decision, so a corrupted message produces no
// bubble, no header, no tool chips — operators just re-issue.

// Deliberately specific so the word "minimax" in normal prose can't
// false-positive. Each entry matches a distinct corruption finger-
// print observed in production runs.
const CORRUPTION_PATTERNS: ReadonlyArray<RegExp> = [
  /\]<\]minimax\[/,                  // literal leaked control sequence
  /<tool_call>[\s\S]*<tool_call>/,   // duplicated tag — fence-loop tell
];

// Returns true when the raw text shows fence corruption. Pure.
export function isCorrupted(text: string): boolean {
  return CORRUPTION_PATTERNS.some((re) => re.test(text));
}
